<template>
  <nav
    class="el-breadcrumb"
    aria-label="Breadcrumb"
  >
    <slot />
  </nav>
</template>

<script setup>
import { provide } from 'vue'

const props = defineProps({
  separator: {
    type: String,
    default: ''
  }
})

provide('breadcrumbSeparator', props.separator)
</script>

<style scoped>
.el-breadcrumb {
  display: flex;
  align-items: center;
}
</style>
